import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  mutation MakeTransfer($sourceId: String!, $destinationIds:[String!]!, $currency: String!, $amount: Float!, $transferType: String!) {
    makeTransfer(sourceId: $sourceId, destinationIds: $destinationIds, currency: $currency, amount: $amount, transferType: $transferType) {
      uuid
      sourceId
      destinationIds
      amount
      currency
      details
      status
      message
    }
  }
`

export const makeTransferKey = getQueryNames(query)[0]

export default query
